import { jsx } from "panel";
import range from "lodash/range";
import { WarningEl } from "common/components/warning";
import { InputEl } from "common/components/input";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SpinnerEl } from "common/components/spinner";
import { ProfileEditablePropertyEl } from "./profile-editable-property";
const Loading = () => /* @__PURE__ */ jsx("div", {
  sel: ".content.mp-skeleton-wrapper"
}, range(6).map((_) => /* @__PURE__ */ jsx("div", {
  sel: ".mp-panel-section"
}, /* @__PURE__ */ jsx("div", {
  sel: ".mp-skeleton-large"
}))));
export function template() {
  const { isCreatingNewPropertyLoading, searchText, showCreateNewProperty } = this.state;
  const profilePropertiesName = this.helpers.hasDataGroupId() ? `Group Profile Properties` : `User Profile Properties`;
  const FilteredProperties = ({
    filteredProperties,
    propertiesLoading
  }) => /* @__PURE__ */ jsx(null, null, filteredProperties.map(({ property, matchParts }) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section"
  }, /* @__PURE__ */ jsx(ProfileEditablePropertyEl, {
    key: `${this.helpers.getRawPropertyName(property)}`,
    attrs: {
      loading: propertiesLoading.includes(this.helpers.getRawPropertyName(property)),
      property,
      "sidebar-mode": this.attr(`sidebar-mode`),
      "match-parts": matchParts,
      "can-write-profile": this.attr(`can-write-profile`)
    },
    on: {
      update: this.helpers.handlePropertyUpdate,
      delete: this.helpers.handlePropertyDelete
    }
  }))));
  const AllProperties = ({
    allProperties,
    propertiesLoading
  }) => /* @__PURE__ */ jsx(null, null, allProperties.map((property) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section"
  }, /* @__PURE__ */ jsx(ProfileEditablePropertyEl, {
    key: `${this.helpers.getRawPropertyName(property)}`,
    attrs: {
      loading: propertiesLoading.includes(this.helpers.getRawPropertyName(property)),
      property,
      "sidebar-mode": this.attr(`sidebar-mode`),
      "can-write-profile": this.attr(`can-write-profile`)
    },
    on: {
      update: this.helpers.handlePropertyUpdate,
      delete: this.helpers.handlePropertyDelete
    }
  }))));
  const CreateNewProperty = () => /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section.new-property-input"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".new-property-title"
  }, "Create ", profilePropertiesName), /* @__PURE__ */ jsx(InputEl, {
    sel: ".name-input",
    attrs: {
      label: `Property Name`
    },
    on: {
      input: this.helpers.handleUpdateNewPropertyName
    },
    hook: {
      insert: ({ elm }) => elm.focus()
    }
  }), /* @__PURE__ */ jsx(InputEl, {
    sel: ".value-input",
    attrs: {
      label: `Property Value`
    },
    on: {
      input: this.helpers.handleUpdateNewPropertyValue
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".confirmation-buttons"
  }, isCreatingNewPropertyLoading ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".new-property-button",
    attrs: {
      theme: ButtonTheme.Tertiary,
      elref: `profileCancelNewProperty`
    },
    on: {
      click: this.helpers.handleCancelNewProperty
    }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".new-property-button",
    attrs: {
      theme: ButtonTheme.Primary,
      elref: `profileSaveNewProperty`
    },
    on: {
      click: this.helpers.handleSaveNewProperty
    }
  }, "Save"))));
  const Properties = () => {
    if (this.helpers.isPropertiesLoading()) {
      return /* @__PURE__ */ jsx(Loading, null);
    }
    if (this.attr(`user-properties-error`)) {
      return /* @__PURE__ */ jsx(WarningEl, {
        attrs: {
          "header-text": `Unable to Display Properties`,
          "body-text": `Please try again later.`,
          theme: `error`
        }
      });
    }
    if (!this.attr(`profile-exists`)) {
      return /* @__PURE__ */ jsx(WarningEl, {
        attrs: {
          "header-text": `No ${profilePropertiesName}`,
          "cta-text": `Setup ${profilePropertiesName}`,
          "cta-href": this.helpers.hasDataGroupId() ? `https://developer.mixpanel.com/reference/group-profiles#group-set-property` : `https://developer.mixpanel.com/reference/user-profiles#profile-set`,
          theme: `no-icon`
        }
      });
    }
    return /* @__PURE__ */ jsx(null, null, !showCreateNewProperty && /* @__PURE__ */ jsx("div", {
      sel: ".profile-demographics-property-management",
      attrs: { elref: `profileProperties` }
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: ".search-input",
      attrs: {
        icon: `search`,
        placeholder: `Search properties`,
        value: searchText,
        elref: `profileSearchBar`,
        tabindex: 0
      },
      props: {
        value: searchText
      },
      on: {
        input: this.helpers.handleUpdateInput
      }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".content"
    }, !showCreateNewProperty && !this.attr(`sidebar-mode`) && /* @__PURE__ */ jsx("div", {
      class: { "create-disabled": !this.attr(`can-write-profile`) }
    }, !this.attr(`can-write-profile`) && /* @__PURE__ */ jsx(TooltipEl, {
      attrs: {
        placement: Placement.Bottom
      }
    }, "You don't have permission to create."), /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".create-new-property-button",
      attrs: {
        icon: `plus`,
        theme: ButtonTheme.Tertiary,
        elref: `profileNewProperty`,
        disabled: !this.attr(`can-write-profile`)
      },
      on: {
        click: this.helpers.handleCreatePropertyButton
      }
    }, "Create New Property")), showCreateNewProperty && /* @__PURE__ */ jsx(CreateNewProperty, null), searchText !== `` ? /* @__PURE__ */ jsx(FilteredProperties, {
      filteredProperties: this.helpers.getFilteredProperties(),
      propertiesLoading: this.helpers.getPropertiesThatAreLoading()
    }) : /* @__PURE__ */ jsx(AllProperties, {
      allProperties: this.helpers.getAllDisplayProperties(),
      propertiesLoading: this.helpers.getPropertiesThatAreLoading()
    })));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".profile-demographics"
  }, !this.attr(`sidebar-mode`) && /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section.properties-header"
  }, profilePropertiesName), /* @__PURE__ */ jsx(Properties, null));
}
